module.exports = __webpack_public_path__ + "static/scale-model-of-christmas-tree-lane-in-oakland-california-71495e68f9fbd037c227eab0f0837140.png";